<template>
  <div class="menu-user">
    <div class="menu-close" @click="onClose">
      <img src="@/assets/images/x-close-black.svg" />
    </div>
    <div class="menu-user-brief">
      <div class="menu-user-avatar">
        <img src="@/assets/images/avatar-menu.svg" alt="" />
      </div>
      <div class="menue-user-name">鈴木太郎様</div>
      <img
        class="menu-dropdown"
        src="@/assets/images/dropdown-right.svg"
        alt=""
        @click="this.isShown = !this.isShown"
      />
    </div>
    <div v-show="isShown" class="menu-user-info">
      <div>
        <img src="@/assets/images/menu-app.svg" alt="" />マイメニュー
      </div>
      <div>
        <img src="@/assets/images/search.svg" alt="" />お気に入り検索
      </div>
      <div>
        <img src="@/assets/images/message-menu.svg" alt="" />メッセージ
      </div>
      <div>
        <img src="@/assets/images/menu-list.svg" alt="" />オプション
      </div>
      <div>
        <img
          src="@/assets/images/advertisement-line.svg"
          alt=""
        />広告オプション
      </div>
      <div>
        <img src="@/assets/images/menu-list.svg" alt="" />各種リスト
      </div>
    </div>
    <div class="link_blue">
      <img src="@/assets/images/menu-notifcation.svg" alt="" />Noti
    </div>
    <div class="link_blue">
      <img src="@/assets/images/notice-push.svg" alt="" />お知らせ
    </div>
    <div class="link_blue">
      <img src="@/assets/images/logout.svg" alt="" />ログアウト
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';

const isShown = ref(true);

const emits = defineEmits(['onClose']);

function onClose() {
  emits('onClose');
}
</script>
<style lang="scss">
.menu-user ~ div {
  border-bottom: 1px solid #f3f3f3;
}
.menu-user {
  font-weight: 600;
  margin: 14px 0px;
  border-bottom: none !important;
  .menu-close {
    padding-bottom: 13px;
  }
  .menu-user-brief {
    display: flex;
    flex-flow: wrap;
    padding: 20px 0;
    align-items: center;
    .menue-user-name {
      flex: 1;
    }
    .menu-user-avatar {
      margin-right: 10px;
    }
    .menu-dropdown {
      width: 9px;
      height: 17px;
    }
  }
  .menu-user-info {
    background: #f7f9fc;
    padding: 8px 17px 21px;
    div {
      margin-bottom: 20px;
      img {
        margin-right: 5px;
      }
    }
    div:last-child {
      margin-bottom: 0px;
    }
  }
  .link_blue {
    padding: 8px 16px;
    img {
      margin-right: 5px;
    }
  }
  .menu-close,
  .link_blue {
    border-bottom: 1px solid #f3f3f3;
  }
  .link_blue:last-child {
    border-bottom: unset;
  }
}
</style>
